import React from 'react';
import { useHistory } from "react-router-dom";
import { GuestLogin, Me, SetToken, SetUser } from '../../../services/Session';

function DropdownProfile({ user }) {
	const history = useHistory();
	return (
		<div className="navbar-item navbar-user dropdown">
			{user?.role?.id <= 1 && (
				<button onClick={() => history.push('/login')} className="navbar-link dropdown-toggle d-flex align-items-center">
					<div className="image image-icon bg-gray-800 text-white">
						<i className="fa fa-user"></i>
					</div>
					<span className="d-none d-md-inline text-white">Login / Register</span>
				</button>
			)}
			{user?.role?.id > 1 && (
				<>
					<a href="#/" className="navbar-link dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown">
						<div className="image image-icon bg-gray-800 text-white">
							<i className="fa fa-user"></i>
						</div>
						<span>
							<span className="d-none d-md-inline text-white">{user?.name}</span><b className="caret"></b>
						</span>
					</a>
					<div className="dropdown-menu dropdown-menu-end me-1">
						<button onClick={() => history.push('/')} className="dropdown-item">Beranda</button>
						<div className="dropdown-divider"></div>
						{user?.role?.id > 2 && <button onClick={() => history.push('/dasbor')} className="dropdown-item">Dasbor</button>}
						<button onClick={() => history.push('/transaksi')} className="dropdown-item d-flex align-items-center">Pesanan<span className="badge bg-danger rounded-pill ms-auto">2</span></button>
						{(user?.role?.id > 2 || user?.is_affiliate) && <button onClick={() => history.push('/affiliate')} className="dropdown-item">Affiliate</button>}
						{user?.role?.id > 2 && <>
							<div className="dropdown-divider"></div>
							{user?.role?.id > 2 && <button onClick={() => history.push('/produk')} className="dropdown-item">Data Produk</button>}
							{user?.role?.id > 2 && <button onClick={() => history.push('/stok-opname')} className="dropdown-item">Stok Opname</button>}
							<div className="dropdown-divider"></div>
							{user?.role?.id > 2 && <button onClick={() => history.push('/laporan')} className="dropdown-item">Laporan</button>}
							{user?.role?.id > 2 && <button onClick={() => history.push('/grafik')} className="dropdown-item">Grafik</button>}
							<div className="dropdown-divider"></div>
							{user?.role?.id > 2 && <button onClick={() => history.push('/pengaturan')} className="dropdown-item">Pengaturan</button>}
						</>}
						<button onClick={() => history.push('/profil')} className="dropdown-item">Profil</button>
						<div className="dropdown-divider"></div>
						<button onClick={() => {
							GuestLogin().then(res => {
								Me(SetToken(res.data.token).access_token).then(res => {
									SetUser(res.data)
									history.go('/')
								})
							})
						}} className="dropdown-item">Keluar</button>
					</div>
				</>
			)}
		</div>
	);
};

export default DropdownProfile;
